import { Dialog, EntityDialog, Fluent, HtmlContentEditor, PanelAttribute, getType, getjQuery } from "@serenity-is/corelib";
import { Authorization, Config, ErrorHandling } from "@serenity-is/corelib";
import { IdleTimeout, setupUIOverrides } from "@serenity-is/pro.extensions";
import { siteLanguageList } from "./Helpers/LanguageList";
import { NotificationHandler } from "./Notification/NotificationHandler";

[NotificationHandler]

export interface TimeoutSettings {
    TimeOut: number;
}


async function fetchTimeoutSettings(): Promise<TimeoutSettings> {
    const response = await fetch('/api/settings/timeout');
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
}

Config.rootNamespaces.push('XPHR');
EntityDialog.defaultLanguageList = siteLanguageList;
HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";

const $ = getjQuery();
if ($?.fn?.colorbox) {
    $.fn['colorbox'].settings.maxWidth = "95%";
    $.fn['colorbox'].settings.maxHeight = "95%";
}

setupUIOverrides();

// Remove two lines below if you prefer entity dialogs to open in panel mode by default like in latest Serenity version
let typeInfo = (getType('Serenity.EntityDialog') as any).typeInfo;
typeInfo.customAttributes = typeInfo.customAttributes.filter((x: any) => !(x instanceof PanelAttribute))

// Make Bootstrap modals use a backdrop by default
Dialog.defaults.backdrop = true;

window.onerror = ErrorHandling.runtimeErrorHandler;
window.addEventListener('unhandledrejection', ErrorHandling.unhandledRejectionHandler);

var meta = Fluent.findFirst('meta[name=username]');
if ((meta.length && meta.attr('content')) ||
    (!meta.length && Authorization.isLoggedIn)) {

    var timeout = 0;
    var warning = 2;
    fetchTimeoutSettings().then(settings => {
        console.log(settings.TimeOut);
        timeout = settings.TimeOut;
        new IdleTimeout({
            activityTimeout: timeout * 60,
            warningDuration: 2 * 60
        });
    }).catch(error => {
        new IdleTimeout({
            activityTimeout: 30 * 60,
            warningDuration: 2 * 60
        });
        console.error('Error fetching timeout settings:', error);
    });
}

